import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { catchError, from, map, Observable, of, switchMap } from 'rxjs';

import { OrganisationDetService } from '../../services/organisation-det.service';
import { handleHttpError } from '../../utils/api';
import { OrganisationDetActions } from '../actions/organisation-det.actions';

@Injectable()
export class OrganisationDetEffects {
  public getAll$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganisationDetActions.getAll),
      switchMap(({ organisationId }) =>
        from(this.service.getAll(organisationId)).pipe(
          map(({ items }) => OrganisationDetActions.getAllSuccess({ dets: items })),
          catchError((error) => of(OrganisationDetActions.getAllFailure({ error }))),
        ),
      ),
    ),
  );

  public getAllFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganisationDetActions.getAllFailure),
      map((error) => handleHttpError(error)),
    ),
  );

  public get$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganisationDetActions.get),
      switchMap(({ organisationId, id }) =>
        from(this.service.getOne(organisationId, id)).pipe(
          map((det) => OrganisationDetActions.getSuccess({ det })),
          catchError((error) => of(OrganisationDetActions.getFailure({ error }))),
        ),
      ),
    ),
  );

  public getFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganisationDetActions.getFailure),
      map((error) => handleHttpError(error)),
    ),
  );

  public create$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganisationDetActions.create),
      switchMap(({ organisationId, payload }) =>
        from(this.service.create(organisationId, payload)).pipe(
          map((det) => OrganisationDetActions.createSuccess({ det })),
          catchError((error) => of(OrganisationDetActions.createFailure({ error }))),
        ),
      ),
    ),
  );

  public createFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganisationDetActions.createFailure),
      map((error) => handleHttpError(error)),
    ),
  );

  public update$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganisationDetActions.update),
      switchMap(({ organisationId, id, payload }) =>
        from(this.service.update(organisationId, id, payload)).pipe(
          map((det) => OrganisationDetActions.updateSuccess({ det })),
          catchError((error) => of(OrganisationDetActions.updateFailure({ error }))),
        ),
      ),
    ),
  );

  public updateFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganisationDetActions.updateFailure),
      map((error) => handleHttpError(error)),
    ),
  );

  public constructor(
    private readonly actions$: Actions,
    private readonly service: OrganisationDetService,
  ) {}
}
